const countdownClock = class extends HTMLElement {
  constructor() {
    super()

    this.countdownDate = Number(this.dataset.date)
    this.date = new Date(this.countdownDate)
    this.days = this.querySelector('[data-days]')
    this.hours = this.querySelector('[data-hours]')
    this.minutes = this.querySelector('[data-minutes]')
    this.seconds = this.querySelector('[data-seconds]')
  }

  connectedCallback () {
    const countdown = setInterval(() => {
      const now = new Date().getTime()
      const difference = this.date - now

      if (difference < 1) {
        this.stopInterval(countdown)
        return
      }

      const days = Math.floor(difference / (1000 * 60 * 60 * 24))
      const hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((difference % (1000 * 60)) / 1000)

      this.days && (this.days.innerText = days.toString().length === 1 ? `0${days}` : days)
      this.hours && (this.hours.innerText = hours.toString().length === 1 ? `0${hours}` : hours)
      this.minutes && (this.minutes.innerText = minutes.toString().length === 1 ? `0${minutes}` : minutes)
      this.seconds && (this.seconds.innerText = seconds.toString().length === 1 ? `0${seconds}` : seconds)
    }, 1000)
  }

  stopInterval(interval) {
    this.classList.add('hide')
    clearInterval(interval)
  }
}

if (typeof window.customElements.get('countdown-clock') === 'undefined') {
  window.customElements.define('countdown-clock', countdownClock)
}